"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing;
    return ({
        pagination: {
            borderBottomWidth: 0
        },
        paginationActions: {
            '& > button': {
                padding: 0,
                marginLeft: spacing(0.5),
                marginRight: spacing(0.5)
            },
            '& > button:last-child': {
                marginRight: 0
            }
        }
    });
});
exports.default = useStyles;
